import { Link } from "react-router-dom";
import { quizzes } from "../../../mocks/quizzes";

const heroQuiz = quizzes[0];

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/df79fc1b0039d04be6e13ed6f8878bcb.jpg"
          alt="FunsTest Hero"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#FF6B6B]/80 via-[#FF8E53]/70 to-[#FBBF24]/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-24 pb-16">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full px-4 py-1.5 mb-6">
            <span className="text-lg">🔥</span>
            <span className="text-white text-sm font-semibold">This Week&apos;s #1 Trending Quiz</span>
          </div>

          {/* Main Headline */}
          <h1 className="text-5xl md:text-7xl font-extrabold text-white leading-tight mb-6"
            style={{ fontFamily: "'Nunito', sans-serif" }}
          >
            Discover
            <br />
            <span className="text-yellow-300">Your True Self</span>
            <br />
            Through Fun!
          </h1>

          <p className="text-white/90 text-lg md:text-xl mb-8 max-w-lg leading-relaxed">
            Join <strong>5M+ teens</strong> taking viral personality quizzes every week. Pick images, answer questions, and unlock the real you — then share with your BFFs!
          </p>

          <div className="flex flex-wrap gap-4">
            <Link
              to={`/quiz/${heroQuiz.id}`}
              className="px-8 py-4 bg-white text-[#FF6B6B] font-extrabold text-base rounded-full hover:scale-105 transition-transform cursor-pointer whitespace-nowrap shadow-lg"
            >
              Take Today&apos;s Quiz ✨
            </Link>
            <Link
              to="/categories"
              className="px-8 py-4 bg-white/20 backdrop-blur-sm border-2 border-white text-white font-bold text-base rounded-full hover:bg-white/30 transition-colors cursor-pointer whitespace-nowrap"
            >
              Browse All Quizzes
            </Link>
          </div>

          {/* Stats */}
          <div className="flex gap-8 mt-10">
            {[
              { num: "5M+", label: "Players" },
              { num: "500+", label: "Quizzes" },
              { num: "4.9★", label: "Rating" },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="text-white font-extrabold text-2xl md:text-3xl"
                  style={{ fontFamily: "'Nunito', sans-serif" }}
                >
                  {stat.num}
                </p>
                <p className="text-white/70 text-xs uppercase tracking-wider">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Floating Quiz Card */}
        <Link
          to={`/quiz/${heroQuiz.id}`}
          className="absolute right-6 top-1/2 -translate-y-1/2 hidden xl:block w-72 bg-white rounded-3xl overflow-hidden cursor-pointer hover:scale-105 transition-transform"
        >
          <div className="w-full h-44">
            <img
              src={heroQuiz.image}
              alt={heroQuiz.title}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="p-4">
            <span className="text-xs font-bold text-[#FF6B6B] uppercase tracking-wider">
              {heroQuiz.categoryLabel}
            </span>
            <h3 className="font-extrabold text-gray-900 text-sm mt-1 leading-snug line-clamp-2"
              style={{ fontFamily: "'Nunito', sans-serif" }}
            >
              {heroQuiz.title}
            </h3>
            <div className="flex items-center justify-between mt-3">
              <span className="text-xs text-gray-400">
                {(heroQuiz.totalPlays / 1000).toFixed(0)}K plays
              </span>
              <span className="px-3 py-1 bg-[#FF6B6B] text-white text-xs font-bold rounded-full">
                Play Now
              </span>
            </div>
          </div>
        </Link>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 animate-bounce">
        <span className="text-white/60 text-xs">Scroll down</span>
        <i className="ri-arrow-down-line text-white/60" />
      </div>
    </section>
  );
}
